// eslint-disable-next-line import/prefer-default-export
export const SET_EDUCATION_DATA = 'SET_EDUCATION_DATA';
